import React from 'react';
import { 
  CheckCircleIcon, 
  XCircleIcon, 
  UserIcon, 
  BuildingOffice2Icon, 
  KeyIcon, 
  ShieldCheckIcon,
  AcademicCapIcon
} from '@heroicons/react/24/outline';

export const StatusMinistro = ({ status,seleccionarIglesia }) => {
  if (!status) return null;

  const esValido = Boolean(status.resultado && status.resultado !== 'ERROR');

  return (
    <div className="w-full bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden my-4">
      <h3 className=" p-4 text-2xl font-bold text-gray-900">Status de la credencial</h3>
      <div className={`p-4 sm:p-6 border-b flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 ${
        esValido ? 'bg-blue-50/60 border-blue-100' : 'bg-red-50/60 border-red-100'
      }`}>
        <div className="flex items-center gap-3">
          {esValido ? (
            <CheckCircleIcon className="w-9 h-9 text-blue-600 shrink-0" />
          ) : (
            <XCircleIcon className="w-9 h-9 text-red-600 shrink-0" />
          )}
          <div>
            <div className="flex items-center gap-2 flex-wrap">
              <h3 className="text-xl font-bold text-gray-900">{status.nombre || 'Sin nombre'}</h3>
              {/* <span className="text-xs font-semibold px-2.5 py-0.5 rounded-full bg-gray-100 text-gray-600 border border-gray-200">
                #{status.id_obrero ?? 'N/A'}
              </span> */}
            </div>
            <p className="text-sm text-gray-600 mt-0.5 flex items-center gap-1.5">
              <AcademicCapIcon className="w-4 h-4 text-gray-400" />
              {status.rango?.trim() || 'Sin rango'} — <span className="font-medium text-gray-700">Región {status.region ?? 'N/A'}</span>
            </p>
          </div>
        </div>

        {/* Badge Banner */}
        <div className={`px-4 py-2 rounded-xl border flex items-center gap-2 font-bold text-sm shadow-sm ${
          esValido 
            ? 'bg-blue-600 text-white border-blue-700' 
            : 'bg-red-600 text-white border-red-700'
        }`}>
          <span>{esValido ? '✓ CREDENCIAL HABILITADA' : '✕ CREDENCIAL INHABILITADA'}</span>
        </div>
      </div>

      <div className="p-4 sm:p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
        
        {/* Columna Izquierda: Validaciones y Permisos */}
        <div className="space-y-4">
          <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider flex items-center gap-1.5">
            <ShieldCheckIcon className="w-4 h-4" />
            Validaciones de Sistema
          </h4>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
            {/* <StatusBadge label="Autorización Región" value={status.aut_region} />
            <StatusBadge label="Autorización Sede Central" value={status.aut_sc} /> */}
            <StatusBadge label="Compromiso Ministerial" value={status.compromiso_ministerial} />
            <StatusBadge label="Vinculado a iglesia eximida" value={status.eximido} />
            <StatusBadge label="Cumple con meses de aportes" value={status.cumple_meses} />
            <StatusBadge label="Credencial Obligatoria" value={status.cred_obligatoria} />
          </div>
        </div>

        {/* Columna Derecha: Datos Adicionales e Iglesia */}
        <div className="space-y-4 flex flex-col justify-between">
          <div className={status?.id_iglesia ? 'cursor-pointer':''} onClick={()=>status?.id_iglesia ? seleccionarIglesia(status?.id_iglesia) : null}>
            <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider flex items-center gap-1.5 mb-3">
              <BuildingOffice2Icon className="w-4 h-4" />
              Iglesia vinculada a su credencial
            </h4>
            <ValorField label="Iglesia asignada" value={status.iglesia} />
          </div>

          {/* <div className="flex items-center justify-between pt-3 border-t border-gray-100 text-xs text-gray-500">
            <div className="flex items-center gap-1.5">
              <KeyIcon className="w-4 h-4 text-gray-400" />
              <span>Cód. Seguridad:</span>
              <ValorInline value={status.cod_seguridad} />
            </div>
            <div className="flex items-center gap-1">
              <UserIcon className="w-4 h-4 text-gray-400" />
              <span>ID Obrero:</span>
              <ValorInline value={status.id_obrero} />
            </div>
          </div> */}
        </div>

      </div>
    </div>
  );
};

/* Componente auxiliar para badges booleanos o con valor */
const StatusBadge = ({ label, value }) => {
  const tieneValor = Boolean(value);

  return (
    <div className={`flex items-center justify-between p-2.5 rounded-lg border text-xs font-medium transition-all ${
      tieneValor 
        ? 'bg-blue-50/60 border-blue-200 text-blue-900' 
        : 'bg-red-50/60 border-red-200 text-red-900'
    }`}>
      <span>{label}</span>
      <span className={`inline-flex items-center justify-center w-5 h-5 rounded-full text-[10px] font-bold ${
        tieneValor ? 'bg-blue-600 text-white' : 'bg-red-600 text-white'
      }`}>
        {tieneValor ? '✓' : '✕'}
      </span>
    </div>
  );
};

/* Componente auxiliar para textos de campos de bloques */
const ValorField = ({ label, value }) => {
  const tieneValor = Boolean(value);

  return (
    <div className={`p-3.5 rounded-xl border text-sm leading-relaxed font-medium ${
      tieneValor 
        ? 'bg-blue-50/40 border-blue-200 text-blue-900' 
        : 'bg-red-50/40 border-red-200 text-red-900'
    }`}>
      {value || `Sin ${label.toLowerCase()}`}
    </div>
  );
};

/* Componente para valores simples en una sola línea */
const ValorInline = ({ value }) => {
  const tieneValor = value !== null && value !== undefined && value !== '';

  return (
    <strong className={`font-mono text-sm px-2 py-0.5 rounded border ${
      tieneValor 
        ? 'bg-blue-50 border-blue-200 text-blue-900' 
        : 'bg-red-50 border-red-200 text-red-900'
    }`}>
      {tieneValor ? value : 'Sin dato'}
    </strong>
  );
};